import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Link} from "react-router-dom"

class TableData extends Component {
    render() {
        const {type, data, classType, keyQuery, valueQuery} = this.props
        return (
            type === 'text' ? <td className={`${classType} text-center`}>{data}</td> :
                <td className={`${classType} text-center`}>
                  <span className="font-18">
                    <Link
                        to={{
                            pathname: "/batches",
                            search: `?${keyQuery}=${valueQuery}`
                        }}
                    >
                      {data || '-'}
                    </Link>
                  </span>
                </td>
        )
    }
}

TableData.propTypes = {
    type: PropTypes.string.isRequired,
    // data: PropTypes.any.isRequired,
    classType: PropTypes.string.isRequired,
    keyQuery: PropTypes.string.isRequired,
    valueQuery: PropTypes.string.isRequired
}

export default TableData